import { Heading } from '@chakra-ui/layout';
import React from 'react';

export type EmojiProps = {
  symbol: string;
  label?: string;
  spaceRight?: boolean;
  spaceLeft?: boolean;
  header?: boolean;
};

const Space = () => <span>&nbsp;&nbsp;</span>;

const Emoji = (props: EmojiProps) => {
  props.label !== undefined &&
    console.assert(props.label.length !== 0, `${Emoji.name} label should not be empty.`, props);

  const inner = (
    <>
      {props.spaceLeft && <Space></Space>}
      {props.symbol}
      {props.spaceRight && <Space></Space>}
    </>
  );

  const attributes = {
    'aria-label': props.label ? props.label : '',
    'aria-hidden': props.label ? false : true,
    role: 'img',
    className: 'emoji',
  };

  if (props.header) {
    return <Heading {...attributes}>{inner}</Heading>;
  } else {
    return <span {...attributes}>{inner}</span>;
  }
};

export default Emoji;
